import React from 'react';
import {LabelAddress} from 'components/Labels';

function PublicAddress(props) {
  const {countryName, state, city} = props;

  return <LabelAddress country={countryName} state={state} city={city} />;
}

export default PublicAddress;
